<template>
  <div class="navigation-menu">
    <ul
      v-for="(section, sectionIndex) in sections"
      :key="sectionIndex"
      class="navigation-menu__section"
    >
      <base-subheading
        v-if="section.title"
        class="navigation-menu__section-title"
      >
        {{ section.title }}
      </base-subheading>

      <component
        :is="item.route ? 'router-link' : 'li'"
        v-for="(item, itemIndex) in section.items"
        :key="itemIndex"
        :to="item.route ? item.route : ''"
        :tag="item.route ? 'li' : ''"
        :class="{ 'navigation-menu__section-item--is-active': item.active }"
        active-class="navigation-menu__section-item--is-active"
        class="navigation-menu__section-item"
        @click="item.onClick ? item.onClick() : () => {}"
      >
        <base-icon
          v-if="item.icon"
          :icon="item.icon"
          class="navigation-menu__section-icon"
        />

        <span class="navigation-menu__section-name">
          {{ item.name }}
        </span>
      </component>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BaseNavigation",
};
</script>

<script setup>
defineProps({
  sections: {
    type: Array,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
@import "./base-navigation-menu.scss";
</style>
